var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFolder28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 8C2 5.79086 3.79086 4 6 4H11.4189C12.3631 4 13.2014 4.60421 13.5 5.5C13.7986 6.39579 14.6369 7 15.5811 7H22C24.2091 7 26 8.79086 26 11V20C26 22.2091 24.2091 24 22 24H6C3.79086 24 2 22.2091 2 20V8Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder28);
export default __webpack_public_path__ + "static/media/folder_28.1c66a724.svg";
export { ForwardRef as ReactComponent };